export const MIN_PROMPT_LENGTH = 15;
export const FORM_FIELD_MAX_LENGTH = 500;
export const EXAMPLE_PROMPTS = {
  BOOK_MEETING: 'bookMeeting',
  CONTACT_US: 'contactUs',
  EVENT_REGISTRATION: 'eventRegistration',
  FEEDBACK_FORM: 'feedbackForm',
  JOB_APPLICATION: 'jobApplication',
  LEAD_GENERATION: 'leadGeneration',
  NEWSLETTER_SIGNUP: 'newsletterSignup',
  SUBSCRIPTION_CANCELLATION: 'subscriptionCancellation',
  SUBSCRIPTION_SIGNUP: 'subscriptionSignup'
};
export const TRACKING_EVENT_ACTIONS = {
  OPEN_MODAL: 'open modal',
  CLOSE_MODAL: 'close modal',
  CLICKED_DISMISS_ALERT: 'clicked dismiss alert',
  CLICKED_ALERT_BRAND_KIT_LINK_BUTTON: 'clicked alert brand kit link button',
  CLICKED_EXAMPLE_PROMPT: 'clicked example prompt',
  UPDATED_FORM_CONTENT_PROMPT: 'updated form content prompt',
  UPDATED_FORM_STYLE_PROMPT: 'updated form style prompt',
  UPDATED_FORM_OTHER_REQUIREMENTS: 'updated form other requirements',
  UPDATED_FORM_USE_BRAND_KIT: 'updated form use brand kit'
};